import HeadComponent from "@js/components/Head";
import EducationCourse from "@js/components/EducationCourse";
import { getCourseFromConfig } from "@js/util/educationUtil";
import {
    Course,
    CoursePageProps,
} from "@js/components/EducationCourse/eduConfig";
import Breadcrumb from "@js/components/Breadcrumb";
import { getAddressFromHeaders } from "@js/util/cookieUtil";
import { getAllCourseProgress } from "@js/prisma/prisma";

const props: CoursePageProps = {
    courseName: "N/A",
    title: "N/A",
    imgSrc: "",
    moduleGroup: [],
    path: "/",
    courseBannerImgLeft: "",
    courseBannerImgRight: "",
};

const defaultProps: { props: Course } = {
    props: props,
};

export async function getServerSideProps(context: any) {
    // resolved url is the requested page (ex. /course/cairomummies)
    let path = context.resolvedUrl;
    try {
        // get courseName which is a string
        const courseName = path.split("/course/")[1];
        //get the correct course information
        let course = getCourseFromConfig(courseName);
        if (!course) {
            return defaultProps;
        }

        const address = getAddressFromHeaders(context.req.headers);
        const allCourseProgress = await getAllCourseProgress(address);
        const coursePageProps: CoursePageProps = course as CoursePageProps;
        coursePageProps.allCourseProgress = allCourseProgress;

        return {
            props: course,
        };
    } catch (e) {
        console.error(e);
        return defaultProps;
    }
}

const CoursePage = (props: CoursePageProps) => {
    const title = props.title;
    let courseTitle = `Course: ${title}`;

    return (
        <>
            <Breadcrumb />
            <HeadComponent title={courseTitle} />
            <EducationCourse {...props} />
        </>
    );
};

export default CoursePage;
